(ns teamoesterreich.user-mode.landing.actual-news.actual-news
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    ))



(defn get-last-news [news-list show-unpublished?]
  (when (and news-list (seqable? news-list))
    (second (first (reverse (sort-by (fn [[uuid n]] (.-seconds ^js (:date n))) (filter (fn [[uuid n]]
                                                                                         (and
                                                                                           (not (false? (:active n)))
                                                                                           (try (< (* (.-seconds ^js (:date n)) 1000) (js/Date.now)) (catch js/Error e false))
                                                                                           (or show-unpublished? (not (false? (:published n))))
                                                                                           ))
                                                                                       news-list)))))))

(defn get-it []
  (let [!news-list (r/cursor store/app-state [:news])
        !publisher (r/cursor store/app-state [:actual-user :publisher])
        !publisher-mode (r/cursor store/app-state [:actual-user :publisher-mode])
        show-unpublished? (and @!publisher @!publisher-mode)
        first-news (get-last-news @!news-list show-unpublished?)
        news-list (filter (fn [uuid n] (and
                                         (not (false? (:active n)))
                                         (try (< (* (.-seconds ^js (:date n)) 1000) (js/Date.now)) (catch js/Error e false))
                                         (or show-unpublished? (not (false? (:published n))))
                                         )) @!news-list)]

    (if (= 0 (count news-list))
      [:div {:data-info "no news"} ""]
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "center"
        :spacing    0
        :style      {:maxWidth "1165px"}
        }
       [mui/grid
        {:item true
         :xs   12
         }
        [:h2
         {:style {;:maxWidth "1165px"
                  :padding "3px" :color "#000000de"}}
         (txt/transl "Aktuelles")]
        [:div
         {:className "news-paper"
          :style     {:cursor             "pointer"
                      :color              "#ffffff"
                      :height             "250px"
                      :marginTop          "3px"
                      :backgroundColor    "#e6e6e6"
                      :backgroundImage    (str "url(" (or (:header-image-uri first-news) "") ")")
                      :backgroundPosition "center" :backgroundRepeat "no-repeat" :backgroundSize "fit"}
          :onClick   #(a/set-page :news-list)
          }
         [:div
          {:class "news-title" :style {:width "100%" :overflow "hidden" :height "30px" :display "inline-block" :marginTop "220px" :backgroundColor "#00000066" :fontSize "1.275rem"}}
          (:title first-news)]
         ]]])

    ))
